(() => {
  if (window.WSProductCardMediaReady) return;
  window.WSProductCardMediaReady = true;
  const strings = window.WSTheme?.strings || {};
  const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches;
  const cardSelector = '[data-product-card]';

  const feedback = (card, message, state) => {
    const node = card.querySelector('[data-card-quick-add-feedback]');
    if (!node) return;
    node.textContent = message || '';
    node.hidden = !message;
    node.dataset.state = state || '';
  };

  const setMedia = (card, nextIndex) => {
    const track = card.querySelector('[data-card-media-track]');
    const media = track ? Array.from(track.querySelectorAll('[data-card-media-index]')) : [];
    if (media.length < 2) return;
    const activeIndex = (nextIndex + media.length) % media.length;
    const target = media[activeIndex];
    card.dataset.cardMediaIndex = String(activeIndex);
    media.forEach((item, index) => item.classList.toggle('is-active', index === activeIndex));
    track.scrollTo({ left: media[activeIndex].offsetLeft, behavior: reducedMotion ? 'auto' : 'smooth' });
    if (track.scrollLeft !== target.offsetLeft) track.scrollLeft = target.offsetLeft;
    const position = card.querySelector('[data-card-media-position]');
    if (position) position.textContent = `${activeIndex + 1} / ${media.length}`;
  };

  const purchaseStrings = strings.homeB || {};
  const pendingVariants = new Set();
  const request = async (url, options = {}) => {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 12000);
    try { return await fetch(url, { ...options, signal: controller.signal }); }
    finally { clearTimeout(timer); }
  };
  const readCart = async () => {
    const response = await request('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!response.ok) throw new Error('cart-read');
    const cart = await response.json();
    if (!Array.isArray(cart.items)) throw new Error('invalid-cart');
    return cart;
  };
  const quantity = (cart, id) => cart.items.reduce((total, line) => total + (Number(line.variant_id || line.id) === id ? line.quantity : 0), 0);
  const addToCart = async (card, button) => {
    const variantId = Number(button.dataset.variantId);
    if (!Number.isSafeInteger(variantId) || button.disabled || pendingVariants.has(variantId)) return;
    pendingVariants.add(variantId);
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    card.dataset.quickAddState = 'loading';
    feedback(card, purchaseStrings.adding || strings.quickAddAdding, 'loading');
    const cartLink = card.querySelector('[data-card-cart-reconcile]');
    if (cartLink) cartLink.hidden = true;
    let before, confirmed = false, submitted = false, rejected = false, unresolved = false;
    try {
      before = await readCart();
      submitted = true;
      const response = await request('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });
      if (!response.ok) {
        rejected = response.status >= 400 && response.status < 500;
        throw new Error('add-response');
      }
      const result = await response.json();
      confirmed = Array.isArray(result.items) && result.items.some(item => Number(item.id || item.variant_id) === variantId && item.quantity >= 1);
      if (!confirmed) throw new Error('invalid-add-response');
    } catch (_) {
      if (submitted && !rejected) {
        try {
          const after = await readCart();
          confirmed = quantity(after, variantId) === quantity(before, variantId) + 1;
        } catch (_) { /* Keep the uncertain request locked until a manual cart review. */ }
        unresolved = !confirmed;
      }
      if (!confirmed) {
        card.dataset.quickAddState = unresolved ? 'uncertain' : 'error';
        feedback(card, unresolved ? purchaseStrings.uncertain : submitted ? purchaseStrings.rejected : purchaseStrings.cart_read_error, unresolved ? 'uncertain' : 'error');
        if (cartLink) cartLink.hidden = !unresolved;
      }
    }
    if (confirmed) {
      card.dataset.quickAddState = 'success';
      document.dispatchEvent(new CustomEvent('ws:card-add-confirmed', { detail: { productId: card.querySelector('[data-card-cart-product-id]')?.dataset.cardCartProductId } }));
      feedback(card, purchaseStrings.added || strings.quickAddAdded, 'success');
      try {
        if (!window.WSThemeCart?.openCartDrawer || await window.WSThemeCart.openCartDrawer(button, strings.cartAdded) === false) throw new Error('drawer-refresh');
      } catch (_) {
        feedback(card, purchaseStrings.drawer_error, 'success');
        if (cartLink) cartLink.hidden = false;
      }
    }
    button.disabled = unresolved;
    button.removeAttribute('aria-busy');
    if (!unresolved) pendingVariants.delete(variantId);
  };

  document.addEventListener('click', (event) => {
    const control = event.target.closest('[data-card-media-previous], [data-card-media-next]');
    if (control) {
      const card = control.closest(cardSelector);
      if (!card) return;
      const current = Number(card.dataset.cardMediaIndex || 0); event.preventDefault(); event.stopPropagation(); setMedia(card, current + (control.matches('[data-card-media-next]') ? 1 : -1));
      return;
    }

    const quickAdd = event.target.closest('[data-card-quick-add]');
    if (!quickAdd || quickAdd.matches('a')) return;
    const card = quickAdd.closest(cardSelector);
    if (!card) return;
    event.preventDefault();
    event.stopPropagation();
    addToCart(card, quickAdd);
  });
  const primeCards = (scope = document) => {
    const cards = scope.matches?.('[data-product-card]') ? [scope] : Array.from(scope.querySelectorAll?.('[data-product-card]') || []);
    cards.forEach((card) => {
      if (card.dataset.cardMediaIndex == null) card.dataset.cardMediaIndex = '0';
      const media = Array.from(card.querySelectorAll('[data-card-media-index]'));
      const activeIndex = Number(card.dataset.cardMediaIndex || 0);
      media.forEach((item, index) => item.classList.toggle('is-active', index === activeIndex));
    });
  };
  primeCards();
  document.addEventListener('shopify:section:load', (event) => primeCards(event.target));
  document.addEventListener('wundersaam:collection-updated', (event) => primeCards(event.detail?.scope || event.target));

})();
